import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  Input,
  ChangeDetectorRef
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { FreeFormTextDataEntity } from '../../../../../models/data-entities';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-free-form-text-data-entity-input',
    templateUrl: './free-form-text-data-entity-input.component.html',
    styleUrls: ['./free-form-text-data-entity-input.component.css'],
    standalone: false
})
export class FreeFormTextDataEntityInputComponent
  extends DataEntityInputComponent
  implements OnInit {
  @Input() entity: FreeFormTextDataEntity;
  labelClass = 'bmd-label-floating';
  placeholder = '';
  @Input() showLabel = true;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  templateForPermitForm: boolean = false

  constructor(public layoutService: LayoutService, componentFactory: ComponentFactoryResolver, ref: ChangeDetectorRef, context : WorkflowContextService) {
    super(layoutService, componentFactory, ref, context);

     //added by priya 16-12-2025

       layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
     //end by priya 16-12-2025
 
   
  }

  ngOnInit() {
    if (this.form && this.form.controls[this.entity.templateCode]) {
      if (
        !this.entity.externalDataSource ||
        !this.entity.externalDataSource.sourceConfig ||
        (this.entity.canEditExternalValue &&
          this.form.controls[this.entity.templateCode])
      ) {
        this.form.controls[this.entity.templateCode].enable();
      } else {
        this.form.controls[this.entity.templateCode].disable();
      }
    }

    if (this.orientation == 'horizontal') {
      this.labelClass = 'label';
    } else {
      if (this.entity.getRestrictionMask()) {
        //this.labelClass = 'bmd-label-static';
      }
    }
    // set the mask anyway cause it might be an empty sting which is falsey
    this.placeholder = this.entity.getRestrictionMask();
  }
  // added by priya 17-12-2025

  onFieldChange(value: any) {
    this.entity.value = value ?? ''
  }
  //  end by priya 17-12-2025 

}
